/* ============================================================
   FortTees theme — global interactions
   Vanilla JS. Uses Shopify AJAX Cart API (/cart/*.js).
   ============================================================ */
(function () {
  "use strict";

  const money = (cents) => {
    const fmt = window.theme && window.theme.moneyFormat;
    const amount = (cents / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    if (fmt && fmt.indexOf("{{") !== -1) {
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    return "$" + amount;
  };

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  /* ---------------- Toast ---------------- */
  let toastEl;
  let toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "toast";
      toastEl.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6L9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(toastEl);
    }
    $("span", toastEl).textContent = msg;
    toastEl.setAttribute("data-open", "true");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.setAttribute("data-open", "false"), 2600);
  }

  /* ---------------- Body scroll lock ---------------- */
  let lockCount = 0;
  function lockScroll(on) {
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    document.body.style.overflow = lockCount > 0 ? "hidden" : "";
  }

  /* ---------------- Cart Drawer ---------------- */
  const CartDrawer = {
    el: null,
    overlay: null,
    init() {
      this.el = $("#CartDrawer");
      this.overlay = $("#DrawerOverlay");
      if (!this.overlay) {
        this.overlay = document.createElement("div");
        this.overlay.className = "drawer-overlay";
        this.overlay.id = "DrawerOverlay";
        document.body.appendChild(this.overlay);
      }
      this.overlay.addEventListener("click", () => this.close());
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") this.close();
      });
      $$("[data-cart-toggle]").forEach((b) =>
        b.addEventListener("click", (e) => {
          e.preventDefault();
          this.open();
        })
      );
      if (this.el) {
        this.el.addEventListener("click", (e) => {
          if (e.target.closest("[data-cart-close]")) this.close();
        });
      }
    },
    open() {
      this.refresh();
      if (this.el) this.el.setAttribute("data-open", "true");
      this.overlay.setAttribute("data-open", "true");
      lockScroll(true);
    },
    close() {
      if (this.el) this.el.setAttribute("data-open", "false");
      this.overlay.setAttribute("data-open", "false");
      lockScroll(false);
    },
    async refresh() {
      try {
        const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
        const cart = await res.json();
        this.render(cart);
        updateCartCount(cart.item_count);
      } catch (e) {
        /* offline / preview */
      }
    },
    render(cart) {
      const body = $("[data-cart-body]", this.el);
      const foot = $("[data-cart-foot]", this.el);
      if (!body) return;
      if (!cart.items || cart.items.length === 0) {
        body.innerHTML =
          '<div class="cart-empty"><p class="h3">Your cart is empty</p><p class="muted">Add pieces from the current line to get started.</p><a class="btn btn--accent" href="/collections/all">Shop the line</a></div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;
      body.innerHTML = cart.items
        .map((item) => {
          const img = item.image
            ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, "_160x$1$2") + '" alt="' + escapeHtml(item.product_title) + '">'
            : "";
          const variant =
            item.variant_title && item.variant_title !== "Default Title"
              ? '<div class="cart-line__variant">' + escapeHtml(item.variant_title) + "</div>"
              : "";
          return (
            '<div class="cart-line" data-line-key="' + item.key + '">' +
            '<a class="cart-line__media" href="' + item.url + '">' + img + "</a>" +
            "<div>" +
            '<a class="cart-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + "</a>" +
            variant +
            '<div class="qty" style="margin-top:.6rem">' +
            '<button type="button" data-qty-down aria-label="Decrease">\u2212</button>' +
            '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-input readonly>' +
            '<button type="button" data-qty-up aria-label="Increase">+</button>' +
            "</div>" +
            '<button class="cart-line__remove" data-line-remove>Remove</button>' +
            "</div>" +
            '<div class="cart-line__price">' + money(item.final_line_price) + "</div>" +
            "</div>"
          );
        })
        .join("");
      const totalEl = $("[data-cart-total]", this.el);
      if (totalEl) totalEl.textContent = money(cart.total_price);

      $$(".cart-line", body).forEach((line) => {
        const key = line.getAttribute("data-line-key");
        $("[data-qty-up]", line).addEventListener("click", () =>
          this.changeQty(key, parseInt($("[data-qty-input]", line).value, 10) + 1)
        );
        $("[data-qty-down]", line).addEventListener("click", () =>
          this.changeQty(key, parseInt($("[data-qty-input]", line).value, 10) - 1)
        );
        $("[data-line-remove]", line).addEventListener("click", () => this.changeQty(key, 0));
      });
    },
    async changeQty(key, quantity) {
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
        });
        const cart = await res.json();
        this.render(cart);
        updateCartCount(cart.item_count);
      } catch (e) {}
    },
  };

  /* ---------------- Add to cart ---------------- */
  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  }

  function updateCartCount(count) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  async function addToCart(form, button) {
    const formData = new FormData(form);
    const original = button ? button.innerHTML : "";
    if (button) {
      button.disabled = true;
      button.innerHTML = "Adding\u2026";
    }
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });
      if (!res.ok) {
        const err = await res.json();
        toast(err.description || "Could not add to cart");
      } else {
        toast("Added to cart");
        await CartDrawer.refresh();
        CartDrawer.open();
      }
    } catch (e) {
      toast("Network error. Try again.");
    } finally {
      if (button) {
        button.disabled = false;
        button.innerHTML = original;
      }
    }
  }

  document.addEventListener("submit", (e) => {
    const form = e.target.closest("form[data-product-form]");
    if (!form) return;
    e.preventDefault();
    addToCart(form, $('[type="submit"]', form));
  });

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav() {
    const nav = $("#MobileNav");
    if (!nav) return;
    const open = () => {
      nav.setAttribute("data-open", "true");
      lockScroll(true);
    };
    const close = () => {
      nav.setAttribute("data-open", "false");
      lockScroll(false);
    };
    $$("[data-menu-open]").forEach((b) => b.addEventListener("click", open));
    nav.addEventListener("click", (e) => {
      if (e.target.closest("[data-menu-close]") || e.target.tagName === "A") close();
    });
  }

  /* ---------------- Product page ---------------- */
  function initProduct() {
    const root = $("[data-product-root]");
    if (!root) return;
    let variants = [];
    try {
      variants = JSON.parse($("[data-variant-json]", root).textContent);
    } catch (e) {
      return;
    }
    const optionInputs = $$("[data-option-index]", root);
    const idField = $("[data-variant-id]", root);
    const priceEl = $("[data-price]", root);
    const compareEl = $("[data-compare]", root);
    const addBtn = $("[data-add-btn]", root);
    const mainImg = $("[data-main-image]", root);

    function selectedOptions() {
      const opts = [];
      $$("[data-option-group]", root).forEach((group) => {
        const active = $('[aria-pressed="true"]', group);
        opts[parseInt(group.getAttribute("data-option-group"), 10)] = active ? active.getAttribute("data-value") : null;
      });
      return opts;
    }

    function currentVariant() {
      const opts = selectedOptions();
      return variants.find((v) => v.options.every((o, i) => o === opts[i]));
    }

    function updateAvailability() {
      const opts = selectedOptions();
      $$("[data-option-group]", root).forEach((group) => {
        const gi = parseInt(group.getAttribute("data-option-group"), 10);
        $$("[data-value]", group).forEach((btn) => {
          const trial = opts.slice();
          trial[gi] = btn.getAttribute("data-value");
          const match = variants.find((v) => v.options.every((o, i) => (trial[i] == null ? true : o === trial[i])));
          const avail = variants.some((v) => v.available && v.options[gi] === btn.getAttribute("data-value") && v.options.every((o, i) => (i === gi || opts[i] == null ? true : o === opts[i])));
          btn.setAttribute("data-available", avail ? "true" : "false");
        });
      });
    }

    function render() {
      const v = currentVariant();
      updateAvailability();
      if (!v) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = "Unavailable";
        }
        return;
      }
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to cart" : "Sold out";
      }
      if (mainImg && v.featured_image && v.featured_image.src) {
        mainImg.src = v.featured_image.src;
      }
    }

    $$("[data-option-group] [data-value]", root).forEach((btn) => {
      btn.addEventListener("click", () => {
        if (btn.getAttribute("data-available") === "false" && btn.getAttribute("aria-pressed") !== "true") return;
        const group = btn.closest("[data-option-group]");
        $$("[data-value]", group).forEach((b) => b.setAttribute("aria-pressed", "false"));
        btn.setAttribute("aria-pressed", "true");
        render();
      });
    });

    // Gallery thumbs
    $$("[data-thumb]", root).forEach((thumb) => {
      thumb.addEventListener("click", () => {
        $$("[data-thumb]", root).forEach((t) => t.setAttribute("aria-current", "false"));
        thumb.setAttribute("aria-current", "true");
        const src = thumb.getAttribute("data-full");
        if (mainImg && src) mainImg.src = src;
      });
    });

    // Quantity
    const qtyInput = $("[data-qty-input]", root);
    if (qtyInput) {
      $("[data-qty-up]", root).addEventListener("click", () => (qtyInput.value = parseInt(qtyInput.value, 10) + 1));
      $("[data-qty-down]", root).addEventListener("click", () => (qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1)));
    }

    render();
  }

  /* ---------------- Collection filtering + sorting ---------------- */
  function initCollection() {
    const root = $("[data-collection-root]");
    if (!root) return;
    const grid = $("[data-product-grid]", root);
    const cards = $$("[data-card]", grid);
    const countEl = $("[data-result-count]", root);
    const sortSelect = $("[data-sort]", root);
    const filterInputs = $$("[data-filter]", root);
    const clearBtn = $("[data-clear-filters]", root);

    function apply() {
      const active = {};
      filterInputs.forEach((inp) => {
        if (inp.checked) {
          const g = inp.getAttribute("data-filter");
          (active[g] = active[g] || []).push(inp.value.toLowerCase());
        }
      });
      let visible = 0;
      cards.forEach((card) => {
        let show = true;
        for (const g in active) {
          const vals = (card.getAttribute("data-" + g) || "").toLowerCase().split("|");
          if (!active[g].some((a) => vals.includes(a))) {
            show = false;
            break;
          }
        }
        card.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (countEl) countEl.textContent = visible + (visible === 1 ? " product" : " products");
    }

    function sort() {
      const val = sortSelect ? sortSelect.value : "manual";
      const arr = cards.slice();
      arr.sort((a, b) => {
        const pa = parseFloat(a.getAttribute("data-price")) || 0;
        const pb = parseFloat(b.getAttribute("data-price")) || 0;
        const ta = (a.getAttribute("data-title") || "").toLowerCase();
        const tb = (b.getAttribute("data-title") || "").toLowerCase();
        switch (val) {
          case "price-asc": return pa - pb;
          case "price-desc": return pb - pa;
          case "title-asc": return ta < tb ? -1 : 1;
          case "title-desc": return ta > tb ? -1 : 1;
          default: return 0;
        }
      });
      arr.forEach((c) => grid.appendChild(c));
    }

    filterInputs.forEach((inp) => inp.addEventListener("change", apply));
    if (sortSelect) sortSelect.addEventListener("change", sort);
    if (clearBtn)
      clearBtn.addEventListener("click", () => {
        filterInputs.forEach((i) => (i.checked = false));
        apply();
      });

    // filter drawer (mobile)
    const filtersEl = $("[data-filters]", root);
    $$("[data-filters-toggle]", root).forEach((b) =>
      b.addEventListener("click", () => {
        const open = filtersEl.getAttribute("data-open") === "true";
        filtersEl.setAttribute("data-open", open ? "false" : "true");
        lockScroll(!open);
      })
    );
    const closeF = $("[data-filters-close]", root);
    if (closeF)
      closeF.addEventListener("click", () => {
        filtersEl.setAttribute("data-open", "false");
        lockScroll(false);
      });
  }

  /* ---------------- Init ---------------- */
  document.addEventListener("DOMContentLoaded", () => {
    CartDrawer.init();
    initMobileNav();
    initProduct();
    initCollection();
    // Reflect current cart count on load
    if (window.theme && typeof window.theme.cartCount === "number") {
      updateCartCount(window.theme.cartCount);
    }
  });

  window.FortTees = { toast, CartDrawer, addToCart };
})();
